"use strict";

/*==============================================================================*
*TRESTLE™ W006
*TRESTLE HUMOUR
*DATA
*Version 1.0
*
*Add new cartoons here only.
*The main W006 JS does not need to be edited when new cartoons are added.
*==============================================================================*/

const TRESTLE_W006_HUMOUR_DATA = [

    {
        date:"2026-08-16",

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/C2026007.webp?v=1786511971"
    },

    {
        date:"2026-08-17",

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/C2026008.webp?v=1786511971"
    },

    {
        date:"2026-08-18",

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/C2026009.webp?v=1786511971"
    },

    {
        date:"2026-08-19",

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/C2026003.webp?v=1786412454"
    }, 

    {
        date:"2026-08-20",

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/C2026005.webp?v=1786412455"
    },


    {
        date:"2026-08-21",

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/C2026004.webp?v=1786412455"
    },

    {
        date:"2026-08-22",

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/C2026001.webp?v=1786412454"
    }

    
];